import {useAppDispatch} from '../../hooks/redux'
import {closeModal} from '../../redux/features/modal'

import {ModalMeta} from '../../types'

import Button from '../../../../commons/src/components/button'
import Headline from '../../../../commons/src/components/headline'
import Modal from '../../../../commons/src/components/modal'
import Paragraph from '../../../../commons/src/components/paragraph'

type Props = {
  meta: ModalMeta
  itemsToDeleteCount: number
  linkedConfigsCount?: number
  onConfirm: () => void
}

const ConfirmDeleteModal = ({meta, itemsToDeleteCount, linkedConfigsCount, onConfirm}: Props) => {
  const dispatch = useAppDispatch()

  return (
    <Modal
      fullscreenMobile={meta.fullscreenMobile}
      headline={<Headline label="Please confirm deletion" size="l" />}
      onClose={() => dispatch(closeModal())}
      buttons={
        <>
          <Button hierarchy="ghost" onClick={() => dispatch(closeModal())}>
            Cancel
          </Button>
          <Button
            appearance="error"
            onClick={() => {
              onConfirm()
              dispatch(closeModal())
            }}
          >
            Delete
          </Button>
        </>
      }
    >
      <Paragraph>
        Are you sure you would like to delete{' '}
        {itemsToDeleteCount === 1 ? 'this item' : `${itemsToDeleteCount} items`}?<br />
        {!!linkedConfigsCount && (
          <strong>
            The item{itemsToDeleteCount === 1 ? ' is' : 's are'} linked to {linkedConfigsCount}{' '}
            material{linkedConfigsCount === 1 ? '' : 's'}.
          </strong>
        )}
      </Paragraph>
    </Modal>
  )
}

export default ConfirmDeleteModal
